import React, { useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination } from 'swiper/modules'
import 'swiper/css'

import TypingTitle from '../TypingTitle'

import { SlideImage, SlideWrapper, Subtitle, SliderContainer } from './styles'

const CotizarSlider = () => {
  const [isMobile, setIsMobile] = useState(false)

  const images = Array.from({ length: 3 }, (_, idx) => `/images/steps/step${idx}-mobile.jpg`)

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 800)
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <SliderContainer>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <Subtitle>Pasos para cotizar</Subtitle>
        <div style={{ height: 50 }}>
          <TypingTitle />
        </div>
      </div>

      {isMobile ? (
        <Swiper
          spaceBetween={20}
          pagination={{ clickable: true }}
          style={{ paddingBottom: 70 }}
          modules={[Pagination]}
          slidesPerView={1.8}
        >
          {images.map((src, index) => (
            <SwiperSlide key={index}>
              <SlideWrapper>
                <SlideImage
                  src={src}
                  alt={`Slide ${index + 1}`}
                  loading="lazy"
                  width={320}
                  height={400}
                />
              </SlideWrapper>
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: 60,
            marginBlockStart: 24,
            marginInline: 50,
          }}
        >
          {images.map((src, index) => (
            <SlideWrapper key={index}>
              <SlideImage src={src} alt={`Paso ${index + 1}`} />
            </SlideWrapper>
          ))}
        </div>
      )}
    </SliderContainer>
  )
}

export default CotizarSlider
